



















import { createComponent } from "@vue/composition-api";
import { useGetters } from "@/helpers";

export default createComponent({
  setup(props, context) {
    const { runes } = useGetters("runes");
    return { runes };
  },
});
